<template>

  <shell :title="$t('titles.users')">

    <router-view></router-view>

  </shell>

</template>

<script setup lang="ts">

import Shell from '../Shell.vue'

</script>
